import { createSlice } from '@reduxjs/toolkit';

interface notification {
    id: string | number,
    title: string,
    message: string,
    date: string,
}

export interface notificationState {
    isNotificationDataLoading: boolean;
    notificationData: Array<notification>;
    newNotificationData:Array<notification>
    notificationError: boolean;
    isRemoveNotificationLoading: boolean;
    isRemoveAllNotificationLoading:boolean;
}

const initialState: notificationState = {
    isNotificationDataLoading: false,
    notificationData: [],
    newNotificationData:[],
    notificationError: false,
    isRemoveNotificationLoading: false,
    isRemoveAllNotificationLoading:false,
}

const notificationReducer = createSlice({
    name: 'notification',
    initialState: initialState,
    reducers: {
        getNotificationDataRequest: (state, action: { payload: string }) => {            
            state.isNotificationDataLoading = true;
        },
        getNotificationDataResponse: (state, action) => {
            state.isNotificationDataLoading = false;
            state.notificationData = action.payload.res;
            state.newNotificationData = action.payload.res;            
        },
        getNotificationDataFailed: (state) => {
            state.isNotificationDataLoading = false;
            state.notificationError = true;            
        },
        removeNotificationRequest: (state) => {
            state.isRemoveNotificationLoading = true;
        },
        removeNotificationResponse: (state, action: any) => {
            state.isRemoveNotificationLoading = false;
            state.newNotificationData = state.newNotificationData.filter(
                (notification) => notification.id !== action.payload.id
            );
        },
        removeNotificationFailed: (state) => {
            state.isRemoveNotificationLoading = false;
        },
        removeAllNotificationsRequest: (state) => {
            state.isRemoveAllNotificationLoading = true;
        },
        removeAllNotificationsResponse: (state, action: any) => {
            state.isRemoveAllNotificationLoading = false;
            state.newNotificationData = [];
        },
        removeAllNotificationsFailed: (state) => {
            state.isRemoveAllNotificationLoading = false;
        },
    },
})


export const notificationActions = notificationReducer.actions;
export default notificationReducer;